import { useApplicationModals } from "app/common/hooks";
import { ModalMolecule } from "app/components/molecules/modal";

function ViewSuccessMsgModal({ onSuccess = () => {} }) {
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("successMessage.view");
  const report = payload?.data;
  const title = payload?.title;
  const message = payload?.message;

  // console.log("errors: ", payload?.data);

  const handleClose = () => closeModal("successMessage.view");
  const handleSuccess = () => {
    closeModal("successMessage.view");
    onSuccess();
  };

  return (
    <ModalMolecule
      show={showStates["successMessage.view"]}
      title={title}
      onClose={handleClose}
      size="xl"
    >
      <ul className="list-disc px-4">
        {report !== null &&
          report?.map((successMsg) => (
            <li className="text-gray-700 font-light">{successMsg}</li>
          ))}
      </ul>
      {message !== null && <p>{message}</p>}
    </ModalMolecule>
  );
}

export default ViewSuccessMsgModal;
